module.exports = __webpack_public_path__ + "img/region_default.fd26ae4b.svg";